import { Directive, Input } from '@angular/core';
import { AppInjectorService } from '@app/core/services/app-injector.service';
import { MenuService } from '@app/menu/services/menu.service';

@Directive()
export abstract class SubNavBaseComponent {
  @Input()
  public force: boolean = false;

  protected readonly menuService!: MenuService;

  constructor() {
    this.menuService = AppInjectorService.injector.get(MenuService);
  }
}
